import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "form-label text-capitalize-first" }
const _hoisted_5 = { value: "" }
const _hoisted_6 = { value: "RATE_UP_ON" }
const _hoisted_7 = { value: "RATE_DOWN_ON" }
const _hoisted_8 = { value: "RATE_UP_UNTIL" }
const _hoisted_9 = { value: "RATE_DOWN_UNTIL" }
const _hoisted_10 = { value: "RATE_SET_ALL" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "form-label text-capitalize-first" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = {
  class: "form-check-label text-capitalize-first",
  for: "updateAllCheckbox"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.rate_change_mode')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mode) = $event)),
              class: "form-select",
              required: ""
            }, [
              _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.select_mode')), 1),
              _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.helper.trans('rate_change_modes.rate_up_on')), 1),
              _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.helper.trans('rate_change_modes.rate_down_on')), 1),
              _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.helper.trans('rate_change_modes.rate_up_until')), 1),
              _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.helper.trans('rate_change_modes.rate_down_until')), 1),
              _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.helper.trans('rate_change_modes.rate_set_all')), 1)
            ], 512), [
              [_vModelSelect, _ctx.formData.mode]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.rate_value')) + " (%)", 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              step: "0.01",
              min: "0",
              max: "100",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.value) = $event)),
              class: "form-control",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.updateAll) = $event)),
                id: "updateAllCheckbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.formData.updateAll]
              ]),
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.update_all_traders')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}